import { Tooltip, styled } from '@teko/ds-desktop';
import { CloseOutlined } from '@teko/ds-icon';
import { BottomSheet } from '@teko/ds-mobile';
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { t } from '../../i18n.es.js';
import { SGC_COLORS } from './constants.es.js';
import { useDevice } from '../../contexts/DeviceContext.es.js';

const giftItemLabel = (gift) => `${gift.alt} x${gift.quantity}`;
const ProductGiftsSgc = ({
  gifts,
  hasGift
}) => {
  var _a;
  const { isMobile } = useDevice();
  const [showSheet, setShowSheet] = useState(false);
  const [hovered, setHovered] = useState(false);
  if (!hasGift || !((_a = gifts == null ? void 0 : gifts.images) == null ? void 0 : _a.length))
    return null;
  const [first, ...rest] = gifts.images;
  const moreCount = rest.length;
  const hasMore = moreCount > 0;
  const giftList = /* @__PURE__ */ React.createElement(GiftList, null, rest.map((gift, index) => /* @__PURE__ */ React.createElement(GiftListItem, {
    key: index
  }, giftItemLabel(gift))));
  const moreBox = /* @__PURE__ */ React.createElement(MoreBox, null, "+", moreCount, " ", t("qu\xE0"));
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(Block, {
    hasMore,
    onMouseEnter: () => {
      if (!isMobile && hasMore)
        setHovered(true);
    },
    onMouseLeave: () => setHovered(false),
    onClick: (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      if (isMobile && hasMore)
        setShowSheet(true);
    }
  }, /* @__PURE__ */ React.createElement(GiftText, null, t("T\u1EB7ng"), ": ", first.alt), hasMore && (isMobile ? moreBox : /* @__PURE__ */ React.createElement(Tooltip, {
    title: giftList,
    placement: "top-end",
    show: hovered,
    triggerHover: false,
    backgroundColor: SGC_COLORS.tooltipBackground,
    textColor: "textTitle"
  }, moreBox))), isMobile && typeof document !== "undefined" ? createPortal(/* @__PURE__ */ React.createElement(FullWidthBottomSheet, {
    show: showSheet,
    contentHeight: "15vh",
    backdropClicked: () => setShowSheet(false)
  }, /* @__PURE__ */ React.createElement(SheetContent, null, /* @__PURE__ */ React.createElement(SheetHeader, null, /* @__PURE__ */ React.createElement(SheetTitle, null, t("Qu\xE0 t\u1EB7ng")), /* @__PURE__ */ React.createElement(CloseOutlined, {
    size: 24,
    onClick: () => setShowSheet(false)
  })), giftList)), document.body) : null);
};
const Wrapper = styled.div`
  width: 100%;
`;
const Block = styled.div(({ hasMore }) => `
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  ${hasMore ? "cursor: pointer;" : ""}
`);
const giftBoxStyles = (theme) => `
  background: ${SGC_COLORS.promoBackground};
  padding: ${theme == null ? void 0 : theme.spacing.s4};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.s};
  color: ${theme == null ? void 0 : theme.colors.textTitle};
  font-style: italic;
  font-size: 12px;
  line-height: 16px;
`;
const GiftText = styled.span(({ theme }) => `
  ${giftBoxStyles(theme)}
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`);
const MoreBox = styled.span(({ theme }) => `
  ${giftBoxStyles(theme)}
  flex: 0 0 auto;
  white-space: nowrap;
`);
const GiftList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;
const GiftListItem = styled.div(({ theme }) => `
  font-size: 12px;
  line-height: 16px;
  color: ${theme == null ? void 0 : theme.colors.textTitle};
`);
const SheetContent = styled.div(({ theme }) => `
  padding: ${theme == null ? void 0 : theme.spacing.s16};
`);
const FullWidthBottomSheet = styled(BottomSheet)`
  left: 0;
  right: 0;
  width: 100%;
`;
const SheetHeader = styled.div(({ theme }) => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${theme == null ? void 0 : theme.spacing.s12};
`);
const SheetTitle = styled.span(({ theme }) => `
  font-size: 16px;
  font-weight: 500;
  color: ${theme == null ? void 0 : theme.colors.textTitle};
`);

export { ProductGiftsSgc, ProductGiftsSgc as default };
